import { Box } from '@mui/material';
import { format } from 'date-fns';
import { UseTableCellProps } from 'react-table';
import { Product } from 'shared/types';
import { isDefaultDotnetDate } from 'shared/utility';

export default function DateColumn({ value }: UseTableCellProps<Product>) {
    return (
        <Box display='flex' justifyContent='center' alignContent='center'>
            {isDefaultDotnetDate(value) ? 'No Approval' : format(new Date(value), 'MM-dd-yy p')}
        </Box>
    );
}
